import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import authService from "data/auth"
import { local, setlocal } from 'data/lib/local-json'
import Client from 'data/_client'

export { ActivityMonitor }

type ActivityMonitorProps = {
  logoutAfter: number
  warnBefore: number
}
function ActivityMonitor(props: ActivityMonitorProps) {
  const [_expiredPollingInterval, setExpiredPollingInterval] = useState<number>()

  useEffect(() => {
    setExpiredPollingInterval(setInterval(() => {  // healthcheck
      if (!local('auth.token')) return
      Client.get('session').catch(logout)
    }, 60000)
    )
  }, [])



  const logout = (err) => {
    if (err.message == 'Failed to fetch') return
    setlocal('rdcf_loggedOutDueToInactivity', true)
    authService.logout()
  }

 
  return null
}

